export default __webpack_public_path__ + "static/media/android-logo-desktop.7cc8a4eb.svg";